import { Navigate } from 'react-router-dom';

/*******************************************************
 * 파일명 : frontend2\src\RootRedirect.js
 * 메뉴 : / 진입 시 사용자 대시보드로 리다이렉트
 *******************************************************/

const RootRedirect = () => {
	return <Navigate to='/home' replace />;
};

export default RootRedirect;
